




















































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch, Provide } from "vue-property-decorator";

const ReducePenalty = () => import("./orderDeal/components/reducePenalty.vue");
const ManualUpgradeTicketDialogue = () =>
  import("./ManualUpgradeTicketDialogue/index.vue");
const RecotdingOrderDeal = () =>
  import("./orderDeal/components/callRecordDetail.vue");
// const callrecordDetail =()=>import("./orderDeal/components/callRecordDetail.vue");
import {
  ticketClient,
  authorClient,
  client,
  collectionServiceClient,
} from "@/api/index";
import { GetVoipQICaseReq } from "@/pbjs/xcommon/collection_pb.js";
import {
  GetVoipQITicketListReq,
  GetTicketListReq,
  BatchAssignTicketReq,
  BatchRecycleTicketReq,
  BatchEntrustTicketReq,
  RollApplyTicketReq,
  ReduceTicketReq,
  GetTicketListParamReq,
  CloseTicketReq,
  ReAudioQualityReq,
  Bool,
} from "@/pbjs/external/ticket/ticket_pb";

import { timeFormat, downloadFile, setValue } from "@/utils/index";
import {
  SearchUserReq,
  BatchGetLoginInfoReq,
  GetOutSourceInfoReq,
} from "@/pbjs/external/user/user_pb";
import { pagnition } from "@/utils/commonConfig";
import { setCommon, handleResponse, setPage, errorMsg } from "@/utils/request";
import { Sort, Rank } from "@/pbjs/xcommon/common_pb";

@Component({
  name: "CombinationProperty",
  components: {
    ReducePenalty,
    ManualUpgradeTicketDialogue,
    RecotdingOrderDeal,
  },
})
export default class CombinationProperty extends Vue {
  @Provide() private resultData: any = [];
  @Provide() private userData: any = [];
  @Provide() private principalData: any = [];
  @Provide() private leftamount: any = null; // 2021-08-21 lin 可减免本金
  @Provide() private penaltyData: any = [];
  @Provide() private token: any;
  @Provide() private pageIndex: number = 1;
  @Provide() private pageSize: number = 20;
  @Provide() private pagerCount: number = 0;
  @Provide() private pagnition: any = pagnition;
  @Provide() private userPageIndex: number = 1;
  @Provide() private userPagerCount: number = 0;
  @Provide() private filterText: string = "";
  @Provide() private isShowNewLoadAttr: boolean = false;
  @Provide() private userId: string | null = "";
  @Provide() private AistatusOptions: any = [
    { id: "1", val: "dashbordDy.Notinspected" },
    { id: "2", val: "dashbordDy.Qualityinspected" },
  ];

  @Provide() private RecotdinCheckList: any = [
    { label: "dashbordDy.normal" },
    { label: "dashbordDy.AbusiveCustomer" },
    { label: "dashbordDy.sop" },
    { label: "dashbordDy.CustomerPromises" },
  ];
  @Provide() private loadTypeOptions: any = [
    { value: 1, name: "固定数值" },
    { value: 2, name: "公式" },
    { value: 3, name: "百分比" },
  ];
  @Provide() private recotdingForm: any = {
    name: null,
    result: [{ label: "" }, { label: "" }, { label: "" }, { label: "" }],
    resultTxt: [{ Text: "" }, { Text: "" }, { Text: "" }, { Text: "" }],
  };
  @Provide() private dynamicTags: any = [[], [], [], []];
  @Provide() private inputVisible: any = [
    { name: 0, bool: false },
    { name: 1, bool: false },
    { name: 2, bool: false },
    { name: 3, bool: false },
  ];
  @Provide() private inputValue: any = [];
  @Provide() private formulaOptions: any = [];
  @Provide() private isEdit: boolean = false;
  @Provide() private onEditRow: any = {};
  @Provide() private showDialogType: number = 0;
  @Provide() private ticketSelection: any = [];
  @Provide() private selectedTicketIds: number[] = [];
  @Provide() private selectedAssignUser: any;
  @Provide() private roleOptions: any = [];
  @Provide() private isEditTicketId: number = 0;
  @Provide() private ticketStatusOptions: any = [];
  @Provide() private ticketTypeOptions: any = [];
  @Provide() private searchUserIds: any = [];
  @Provide() private Aiscorerange1: any = "";
  @Provide() private Aiscorerange2: any = "";
  @Provide() private Humanscorerange1: any = "";
  @Provide() private Humanscorerange2: any = "";
  @Provide() private userForm: any = {
    email: "",
    name: "",
    role: "",
  };
  @Provide() private ruleForm: any = {
    itemId: "",
    ticketId: null,
    orderId: null,
    customerId: null,
    callRecordId: null,
    createTimeRange: [],
    completeTimeRange: [],
    closeTimeRange: [],
    assignTimeRange: [],
    status: "",
    assignName: "",
    UrgeResult: "",
    assignUId: null,
    collectionName: "",
    attrIds: [],
    isReloan: null,
    outsource: null,
    belongCompany: null,
    roleList: null,
    isRoll: null,
    isStage: null,
    TicketTag: null,
    overdueReason: [],
    Aitimerange: [],
    Aistatus: "",
    Aiscorerange1: "",
    Aiscorerange2: "",
    Humanscorerange1: "",
    Humanscorerange2: "",
    finalscore1: "",
    finalscore2: "",
  };
  @Provide() private principalForm: any = {
    principal: null,
    reason: "",
  };
  @Provide() private ticketData: any = {};
  @Provide() private penaltyForm: any = {
    interest: null,
    penalty: null,
    reason: "",
  };
  @Provide() private rules: any = {
    // orderId: [{ required: true, message: '请输入', trigger: 'blur' }]
  };
  @Provide() private reloanOptions: any = [
    { name: "v0707.FirstLoan", value: Bool.BOOL_NO },
    { name: "v0707.Reloan", value: Bool.BOOL_YES },
  ];
  @Provide() private UrgeResultOptions: any = []; // 催收结果下拉选项
  @Provide() private TicketTagMapOptions: any = []; // 印度业务线下拉选项
  @Provide() private isGetTicketListActionDone: boolean = false;
  @Provide() private isShowManualUpgradeTicketDialogue: boolean = false;
  @Provide() private isGetTicketListExcelActionDone: boolean = false;
  @Provide() private isgetReAudioQuality: boolean = false;
  @Provide() private rowMessage: any = {};
  @Provide() private calldirection: any = "";
  @Provide() private hangupcause: any = "";
  @Provide() private starttimestamp: any = "";
  @Provide() private Aging: any = "";
  // @Provide() private calltextList: any = '';
  @Provide() private audiorecordurl: any = "";
  // lee 手动升级操作的接口请求是否完成，布尔值
  @Provide() private isGetManualUpgradeTicketActionDone: boolean = false;
  @Provide() private OverdueDay: string = "";
  @Provide() private isSearchUserActionDone: boolean = false;
  @Provide() private companyOptions: any = [];
  @Provide() private companyValue: number | null = null;
  @Provide() private isSelectedIdSearch: boolean = false;
  // @Provide() private outsourceOptions: any = [
  //   { name: "内催", value: Bool.BOOL_NO },
  //   { name: "委外", value: Bool.BOOL_YES }
  // ];
  @Provide() private outsourceOptions: any = [
    { name: "normal", value: Bool.BOOL_NO },
    { name: "outsourcing", value: Bool.BOOL_YES },
  ];
  @Provide() private belongCompanyOptions: any = [];
  @Provide() private sortCondition: any = {
    prop: null,
    order: null,
  };
  @Provide() private recotData: any = {};
  @Provide() private isEditRow: any = {};
  @Provide() private country: any = localStorage.getItem("country"); // 国家，字段差异化展示
  @Provide() private isShowSearchRegion: boolean = true;
  @Provide() private rollOptions: any = [
    { name: "Normal Ticket", value: Bool.BOOL_NO },
    { name: "Extension Ticket", value: Bool.BOOL_YES },
  ];

  @Provide() private StageOptions: any = [
    { name: "Single payment", value: Bool.BOOL_NO },
    { name: "Partial payment", value: Bool.BOOL_YES },
  ];
  @Provide() private overdueReasonOptions: any = []; //逾期原因
  private created() {
    // window.addEventListener('keyup', this.searchUserAction);
    this.token = localStorage.getItem("token");
    this.userId = localStorage.getItem("userid");
    this.getTicketListParam();
    this.getRoleListAPI();
    this.getTicketList();
  }
  @Provide() private showDialogTypeMore: boolean = false;
  @Provide() private sopeRow: any = "";
  @Provide() private isShowManualUpgradeTicketDialogue1: boolean = false;
  @Provide() private showTimesTips: any = {
    showlefttotaltips: null,
    lefttotalgroup: "",
    lefttotalstaff: "",
  }; //减免次数展示

  @Provide() private principalDone: Boolean = false;
  private showDiffTypeDialog(type: number) {
    this.showDialogType = type;
  }
  private hideManualUpgradeTicketDialogue(val: any) {
    this.isShowManualUpgradeTicketDialogue = false;
  }
  private hideManualUpgradeTicketDialogue1(val: any) {
    this.isShowManualUpgradeTicketDialogue1 = false;
  }
  private handleCurrentChange(val: any) {
    this.pageIndex = Number(val);
    //展示表格数据
    this.getTicketList();
  }
  private handleSizeChange(val: any) {
    this.pageSize = Number(val);
    //展示表格数据
    this.getTicketList();
  }
  private handleClose(tag: any, index: number) {
    this.dynamicTags[index].splice(this.dynamicTags[index].indexOf(tag), 1);
  }

  private showInput(index: number) {
    this.inputVisible[index].bool = true;
    this.$nextTick(() => {
      // this.$refs.saveTagInput.$refs.input.focus();
    });
  }
  private handleInputConfirm(index: number) {
    let inputValue = this.inputValue[index];
    if (inputValue) {
      this.dynamicTags[index].push(inputValue);
    }
    this.inputVisible[index].bool = false;
    this.inputValue[index] = "";
  }
  //查询项数字校验
  private inputFuction(e: any, type: string) {
    switch (type) {
      case "ticketId":
        this.ruleForm.ticketId = e.replace(/[^0-9]/g, "");
        break;
      case "orderId":
        this.ruleForm.orderId = e.replace(/[^0-9]/g, "");
        break;
      case "callRecordId":
        this.ruleForm.callRecordId = e.replace(/[^0-9]/g, "");
        break;
    }
  }
  //点击上一页
  private handlePrevChange(val: any) {
    if (this.pageIndex > 0) {
      //展示表格数据
      this.getTicketList();
    }
  }
  private goRecodingDetailPage(row: any) {
    // this.getVoipQICaseReq(row)
    this.sopeRow = row;
    let routeData: any = this.$router.resolve({
      path: "/recordingDail",
      query: {
        id: row.id,
        title: "Order",
        callrecordid: row.callrecordid,
        // status: row.ticketstatus,
      },
    });
    window.open(routeData.href, "_blank");
    // window.open( path:'/recordingDail',)status:row.status,
    // this.isShowManualUpgradeTicketDialogue1=true
    // this.showDialogType=9t
    // this.rowMessage=row
  }
  //点击下一页
  private handleNextChange(val: any) {
    //展示表格数据
    this.getTicketList();
  }
  private getTicketListAction() {
    this.isGetTicketListActionDone = true;
    this.pageIndex = 1;
    this.getTicketList();
  }
  private getTicketListExcelAction() {
    this.isGetTicketListExcelActionDone = true;
    // this.pageIndex = 1;
    this.getTicketListExcel();
  }
  private getReAudioQuality() {
    this.isgetReAudioQuality = true;
    this.ReAudioQuality();
  }
  //重新计算AI质检得分
  private ReAudioQuality() {
    // row.disabled=true
    let request: any = new ReAudioQualityReq();
    request.setCommonin(setCommon());
    ticketClient.reAudioQuality(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        // if (data.commonout == undefined) {
        //   this.isgetReAudioQuality = false;
        //   this.$message.success(this.$tc("dashbordDy.resultsafterwhile"));
        // } else
        if (data.commonout.code === 0) {
          // row.isShow = false;
          this.isgetReAudioQuality = false;

          this.$message.success(this.$tc("dashbordDy.resultsafterwhile"));
        } else {
          this.isgetReAudioQuality = false;

          this.$message.error(
            data.commonout.errmsg || err.message || data.message
          );
        }
      }
      if (err) {
        this.isgetReAudioQuality = false;

        // row.isShow = true;
        if (err.code == 16) {
          this.$router.push("./login");
        } else {
          this.$message.error(
            err.commonout ? err.commonout.errmsg : err.message
          );
        }
      }
    });
  }
  // lee 手动升级操作
  private showManualUpgradeTicketDialogue() {
    this.isShowManualUpgradeTicketDialogue = true;
  }
  private handleAssignCurrentChange(val: any) {
    this.userPageIndex = Number(val);
    //展示表格数据
    this.searchUser();
  }

  //点击上一页
  private handleAssignPrevChange(val: any) {
    if (this.userPageIndex > 0) {
      //展示表格数据
      this.searchUser();
    }
  }

  //点击下一页
  private handleAssignNextChange(val: any) {
    //展示表格数据
    this.searchUser();
  }

  private handleAssignSizeChange(val: any) {
    this.pageSize = Number(val);
    //展示表格数据
    this.searchUser();
  }

  private searchUserAction() {
    this.isSearchUserActionDone = true;
    this.userPageIndex = 1;
    this.searchUser();
  }

  private resetForm(formName: string) {
    const ref: any = this.$refs[formName];
    ref.resetFields();
    this.ruleForm.Humanscorerange1 = "";
    this.ruleForm.Humanscorerange2 = "";
    this.ruleForm.Aiscorerange1 = "";
    this.ruleForm.Aiscorerange2 = "";
    this.ruleForm.finalscore1 = "";
    this.ruleForm.finalscore2 = "";
  }

  private showOrHideSearchRegion() {
    this.isShowSearchRegion = !this.isShowSearchRegion;
  }

  private sortChange(val: any) {
    switch (val.prop) {
      case "handlenum":
        this.sortCondition.prop = Sort.SORT_BY_HANDLE_NUM;
        break;
      case "lasthandletime":
        this.sortCondition.prop = Sort.SORT_BY_LAST_HANDLE_TIME;
        break;
      case "partialcompletetime":
        this.sortCondition.prop = Sort.SORT_BY_PARTIAL_COMPLETE_TIME;
        break;
      case "nexthandletime":
        this.sortCondition.prop = Sort.SORT_BY_PROMISE_REPAY_TIME;
        break;
      case "completetime":
        this.sortCondition.prop = Sort.SORT_BY_COMPLETE_TIME;
        break;
      case "overdueday":
        this.sortCondition.prop = Sort.SORT_BY_OVERDUE_DAY;
        break;
      case "remainamount":
        this.sortCondition.prop = Sort.SORT_BY_REMAIN_AMOUNT;
        break;
      default:
        this.sortCondition.prop = Sort.SORT_UNSPECIFIED;
        break;
    }
    switch (val.order) {
      case "descending":
        this.sortCondition.order = Rank.RANK_DESC;
        break;
      case "ascending":
        this.sortCondition.order = Rank.RANK_ASC;
        break;
      default:
        this.sortCondition.order = Rank.RANK_UNSPECIFIED;
        break;
    }
    this.getTicketListAction();
  }

  private massAssign() {
    if (this.ticketSelection.length > 0) {
      // this.showDialogTypeMore=true
      this.showDialogType = 1;
      this.searchUser();
    } else {
      this.$message.error("Please choose the order classify");
    }
  }

  private confirmMassAssign() {

    this.findSelectedIds();
    this.batchAssignTicket();
  }

  private massRecyle() {
    if (this.ticketSelection.length > 0) {
      this.$confirm(this.$tc("ticket.AreYouSure"), "tips", {
        confirmButtonText: this.$tc("authority.ok"),
        cancelButtonText: this.$tc("authority.cancel"),
        type: "warning",
      })
        .then(() => {
          this.findSelectedIds();
          this.batchRecycleTicket();
        })
        .catch(() => {});
    } else {
      this.$message.error("Pls choose the order classify");
    }
  }

  private massOutsource() {
    if (this.isSelectedIdSearch) {
      this.getOutSourceInfo();
      this.showDialogType = 4;
    } else {
      this.$message.error("Pls choose the order classify");
    }
    // this.$confirm(this.$tc('ticket.AreYouSure'), "提示", {
    //   confirmButtonText: this.$tc('authority.ok'),
    //   cancelButtonText: this.$tc('authority.cancel'),
    //   type: "warning"
    // })
    //   .then(() => {
    //     this.findSelectedIds();
    //     this.batchEntrustTicket();
    //   })
    //   .catch(() => {});
  }

  private doMassOutsource() {
    this.findSelectedIds();
    this.batchEntrustTicket();
  }

  private applyRenewal(row: any) {
    this.$confirm(this.$tc("ticket.AreYouSure"), "tips", {
      confirmButtonText: this.$tc("authority.ok"),
      cancelButtonText: this.$tc("authority.cancel"),
      type: "warning",
    }).then(() => {
      this.rollApplyTicket();
    });
  }

  private principalReduction(row: any) {
    this.isEditRow = row;
    this.showDialogType = 2;
    this.isEditTicketId = row.id;
    this.reduceTicket(row);
  }
  //减免本金  弹框点击确定
  private confirmPrincipalReduction() {
    this.doReducePrincipal();
  }

  private principalChange(e: any) {
    this.principalForm.principal = e;
  }

  private penaltyReduction(row: any) {
    this.isEditRow = row;
    this.showDialogType = 3;
    this.isEditTicketId = row.id;
    this.ticketData = row;
    // this.reduceTicket(row);
  }

  private handleSelectionChange(val: any) {
    this.ticketSelection = val;
  }

  private handleRoleChange(val: any) {
    this.selectedAssignUser = val;
  }

  private findSelectedIds() {
    this.selectedTicketIds = [];
    this.ticketSelection.forEach((item: any) => {
      this.selectedTicketIds.push(item.id);
    });
  }

  private closeDialog() {
    if (this.showDialogType === 2) {
      this.resetForm("principalForm");
    } else if (this.showDialogType === 3) {
      this.resetForm("penaltyForm");
    }
    this.showDialogType = 0;
  }

  private goCollectionDetailPage(row: any) {
    let routeData: any = this.$router.resolve({
      path: "collectionDetail",
      query: {
        id: row.relatedid,
        type: row.casetype == 1 ? "repay" : "overdue", // 调整区分 催收 和 提醒
        orderId: row.orderid,
      },
    });
    window.open(routeData.href, "_blank");
  }

  private goOrderLoggingPage(row: any) {
    let routeData: any = this.$router.resolve({
      path: "orderLogging",
      query: {
        itemId: row.itemid,
        ticketId: row.id,
      },
    });
    window.open(routeData.href, "_blank");
  }
  private closeTicket(row: any) {
    this.$confirm(this.$tc("ticket.AreYouSure"), "tips", {
      confirmButtonText: this.$tc("authority.ok"),
      cancelButtonText: this.$tc("authority.cancel"),
      type: "warning",
    }).then(() => {
      this.doCloseTicket(row);
    });
  }
  private doCloseTicketFuc(data: any) {
    this.$message({
      type: "success",
      message: "Success!",
    });
    this.getTicketList();
  }
  private doCloseTicket(row: any) {
    let request: any = new CloseTicketReq();
    request.setCommonin(setCommon());
    request.setTicketid(Number(row.id));
    request.setItemid(Number(row.itemid));
    ticketClient.closeTicket(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        let _fuc = this.doCloseTicketFuc;
        handleResponse(data, _fuc);
        // if (!data.commonout || (data.commonout.code == 0)) {
        //   // this.$message({
        //   //   type: "success",
        //   //   message: "Success!"
        //   // });
        //   // this.getTicketList();
        // } else if (data.code == 100100 || data.code == 100101) {
        //   this.$router.push("./login");
        // } else {
        //   this.$message.error(data.errmsg || data.message);
        // }
      }
      if (err) {
        if (err.code == 16) {
          this.$router.push("./login");
        } else {
          this.$message.error(err.errmsg || err.message);
        }
      }
    });
  }
  private getRoleListAPIFuc(data: any) {
    if (data.usergroupinfosList) {
      this.roleOptions = data.usergroupinfosList;
    }
  }
  private getRoleListAPI() {
    let request: any = setCommon();
    authorClient.listUserGroup(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        let _fuc = this.getRoleListAPIFuc;
        handleResponse(data, _fuc);
        // if (!data.commonout || (data.commonout.code == 0)) {
        //   if (data.usergroupinfosList) {
        //     this.roleOptions = data.usergroupinfosList;
        //   }
        // } else if (data.code == 100100 || data.code == 100101) {
        //   this.$router.push("./login");
        // } else {
        //   this.$message.error(data.commonout.errmsg);;
        // }
      }
      if (err) {
        errorMsg(err);
      }
    });
  }
  private getOutSourceInfoFuc(data: any) {
    this.companyOptions = data.companyinfosList;
  }
  private getOutSourceInfo() {
    let request: any = new GetOutSourceInfoReq();
    request.setCommonin(setCommon());
    request.setExectype(2);
    client.getOutSourceInfo(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        let _fuc = this.getOutSourceInfoFuc;
        handleResponse(data, _fuc);
        //  if (!data.commonout || (data.commonout.code == 0)) {
        //     this.companyOptions = data.companyinfosList;
        // } else if (data.code == 100100 || data.code == 100101) {
        // this.$router.push("./login");
        // } else {
        // this.$message.error(data.commonout.errmsg);;
        // }
      }
      if (err) {
        errorMsg(err);
      }
    });
  }
  private batchGetLoginInfoFuc(data: any) {
    let map: any = new Map(data.logininfomapMap);
    this.userData.forEach((item: any) => {
      if (map.has(item.id) && map.get(item.id).status) {
        this.$set(item, "online", this.$t("v0707.Yes"));
      } else {
        this.$set(item, "online", this.$t("v0707.No"));
      }
      // item.online = map.has(item.id) && map.get(item.id).status;
    });
  }
  private batchGetLoginInfo() {
    let request: any = new BatchGetLoginInfoReq();
    request.setCommonin(setCommon());
    request.setUseridList(this.searchUserIds);
    client.batchGetLoginInfo(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        let _fuc = this.batchGetLoginInfoFuc;
        handleResponse(data, _fuc);
        // if (!data.commonout || (data.commonout.code == 0)) {
        //     let map: any = new Map(data.logininfomapMap);
        //     this.userData.forEach((item: any) => {
        //         if (map.has(item.id) && map.get(item.id).status) {
        //             this.$set(item, 'online', this.$t('v0707.Yes'));
        //         } else {
        //             this.$set(item, 'online', this.$t('v0707.No'));
        //         }
        //         // item.online = map.has(item.id) && map.get(item.id).status;
        //     });
        // } else if (data.code == 100100 || data.code == 100101) {
        //   this.$router.push("./login");
        // } else {
        //   this.$message.error(data.commonout.errmsg);;
        // }
      }
      if (err) {
        errorMsg(err);
      }
    });
  }
  // 查询
  private getTicketListFuc(data: any) {
    this.pagerCount = data.pageout.total;
    this.resultData = [];
    data.listList.forEach((item: any, index: number) => {
      let _obj: any = {
        casename: item.casename,
        assignname: item.assignname,
        callrecordid: item.audioid,
        collectionname: item.collectionname,
        ticketstatus: item.ticketstatus,
        // ticketstatusId: item.ticketstatus,
        urgeresult: item.urgeresult,
        overduereason: item.overduereason,
        aiscore: item.aiscore == -999 ? "-" : item.aiscore,
        humanscore: item.humanscore == -999 ? "-" : item.humanscore,
        finalscore: item.finalscore == -999 ? "-" : item.finalscore,
        aitime: item.aitime && timeFormat(item.aitime),
        aistatus:
          item.aistatus == 1
            ? this.$tc("dashbordDy.Notinspected")
            : item.aistatus == 0
            ? ""
            : this.$tc("dashbordDy.Qualityinspected"),
      };
      let otherInfo: any = Object.assign({}, item);
      let ordertags = item.ordertags;
      let tickettags = item.tickettagsList;
      let casetype = item.casetype;
      item = item.ticket;
      item.ordertags = ordertags;
      item.tickettags = tickettags;
      item.casetype = casetype;
      item.ctime = item.ctime && timeFormat(item.ctime);
      item.assigntime = item.assigntime && timeFormat(item.assigntime);
      item.starttime = item.starttime && timeFormat(item.starttime);
      item.lasthandletime =
        item.lasthandletime && timeFormat(item.lasthandletime);
      item.nexthandletime =
        item.nexthandletime && timeFormat(item.nexthandletime);
      item.partialcompletetime =
        item.partialcompletetime && timeFormat(item.partialcompletetime);
      item.expiretime = item.expiretime && timeFormat(item.expiretime);
      item.closetime = item.closetime && timeFormat(item.closetime);
      item.completetime = item.completetime && timeFormat(item.completetime);
      item.isreloan = item.isreloan
        ? this.$t("v0707.Reloan")
        : this.$t("v0707.FirstLoan");
      item.isstage =
        item.isstage == 0
          ? this.$t("Single payment")
          : this.$t("Partial payment");
      this.belongCompanyOptions.forEach((i: any) => {
        if (i.value == item.entrustcompany) {
          item.entrustcompanytext = i.name;
        }
      });
      item.isentrusttext = item.isentrust
        ? this.$t("Outsourcing")
        : this.$t("Local Collection");
      item.lasturgeremark = otherInfo.lasturgeremark;
      item.overdueday = otherInfo.overdueday;
      item.phoneobjectset = otherInfo.phoneobjectset;
      item.urgetypeset = otherInfo.urgetypeset;
      item.risklevel = otherInfo.risklevel;
      this.resultData[index] = item;
      Object.assign(this.resultData[index], _obj);
      this.isSelectedIdSearch = true; // this.ruleForm.itemId ? true : false;
    });
  }
  // 导出时需限制所选时间段不可超过一个月，如不符合则提示：
  //   请选择连续时间不超过一个月的数据。=Pls export data within the range of one month=Por favor, exporta datos dentro del rango de un mes.
  private limitInOneMonth(obj: any, begin: any, end: any) {
    if (obj && begin) {
      //   new Date(begin).getTime(),
      //   new Date(end).getTime(),
      //   new Date(begin).getMonth() === new Date(end).getMonth(),
      //   new Date(begin).getMonth() + 1 === new Date(end).getMonth()
      // );
      if (
        new Date(begin).getTime() < new Date(end).getTime() &&
        new Date(end).getTime() <=
          new Date(begin).getTime() + 31 * 24 * 60 * 60 * 1000
      ) {
        return true;
      } else {
        this.$message.warning(
          "Pls export data within the range of one month=Por favor, exporta datos dentro del rango de un mes"
        );
        return false;
      }
    } else {
      return true;
    }
  }
  private limitTimeRange() {
    if (
      (this.ruleForm.createTimeRange && this.ruleForm.createTimeRange[0]) ||
      (this.ruleForm.completeTimeRange && this.ruleForm.completeTimeRange[0]) ||
      (this.ruleForm.closeTimeRange && this.ruleForm.closeTimeRange[0]) ||
      (this.ruleForm.assignTimeRange && this.ruleForm.assignTimeRange[0])
    ) {
      if (
        this.limitInOneMonth(
          this.ruleForm.createTimeRange,
          this.ruleForm.createTimeRange
            ? this.ruleForm.createTimeRange[0]
            : false,
          this.ruleForm.createTimeRange
            ? this.ruleForm.createTimeRange[1]
            : false
        ) &&
        this.limitInOneMonth(
          this.ruleForm.completeTimeRange,
          this.ruleForm.completeTimeRange
            ? this.ruleForm.completeTimeRange[0]
            : false,
          this.ruleForm.completeTimeRange
            ? this.ruleForm.completeTimeRange[1]
            : false
        ) &&
        this.limitInOneMonth(
          this.ruleForm.closeTimeRange,
          this.ruleForm.closeTimeRange
            ? this.ruleForm.closeTimeRange[0]
            : false,
          this.ruleForm.closeTimeRange ? this.ruleForm.closeTimeRange[1] : false
        ) &&
        this.limitInOneMonth(
          this.ruleForm.assignTimeRange,
          this.ruleForm.assignTimeRange
            ? this.ruleForm.assignTimeRange[0]
            : false,
          this.ruleForm.assignTimeRange
            ? this.ruleForm.assignTimeRange[1]
            : false
        )
      ) {
        return true;
      } else {
        this.$message.warning(
          "Pls export data within the range of one month=Por favor, exporta datos dentro del rango de un mes"
        );
        return false;
      }
    }
    this.$message.warning(
      "Pls export data within the range of one month=Por favor, exporta datos dentro del rango de un mes"
    );
    return false;
  }
  //  必传参数处理
  private dwGetTicketListReqParamsNeed() {
    if (
      this.ruleForm.ticketId ||
      this.ruleForm.orderId ||
      this.ruleForm.caseId ||
      this.ruleForm.itemId
    ) {
      return true;
    } else {
      this.isGetTicketListExcelActionDone = false;
      this.$message.error(
        this.$tc(
          "pls make sure you’ve provided one of Ticket ID/Loan ID/Case ID/Ticket category at least"
        )
      );
      return false;
    }
  }
  //  搜索和导出参数处理
  private dwGetTicketListReqParams() {
    let arg = {
      pageIndex: this.pageIndex,
      pageSize: this.pageSize,
      prop: this.sortCondition.prop,
      order: this.sortCondition.order,
    };
    let params = [
      {
        type: "number",
        key: "itemId",
        value: Number(this.ruleForm.itemId),
      },
      {
        type: "string",
        key: "ticketId",
        value: this.ruleForm.ticketId,
      },
      {
        type: "string",
        key: "orderId",
        value: this.ruleForm.orderId,
      },
      {
        type: "string",
        key: "customerId",
        value: this.ruleForm.customerId,
      },
      {
        type: "string",
        key: "caseId",
        value: this.ruleForm.caseId,
      },
      {
        type: "string",
        key: "status",
        value: this.ruleForm.status.join(),
      },
      {
        type: "string",
        key: "assignName",
        value: this.ruleForm.assignName,
      },
      {
        type: "string",
        key: "assignUId",
        value: this.ruleForm.assignUId,
      },
      {
        type: "string",
        key: "createTimeRange",
        value:
          timeFormat(
            this.ruleForm.createTimeRange
              ? this.ruleForm.createTimeRange[0]
              : undefined
          ) +
          " - " +
          timeFormat(
            this.ruleForm.createTimeRange
              ? this.ruleForm.createTimeRange[1]
              : undefined
          ),
      },
      {
        type: "string",
        key: "completeTimeRange",
        value:
          timeFormat(
            this.ruleForm.completeTimeRange
              ? this.ruleForm.completeTimeRange[0]
              : undefined
          ) +
          " - " +
          timeFormat(
            this.ruleForm.completeTimeRange
              ? this.ruleForm.completeTimeRange[1]
              : undefined
          ),
      },
      {
        type: "string",
        key: "closeTimeRange",
        value:
          timeFormat(
            this.ruleForm.closeTimeRange
              ? this.ruleForm.closeTimeRange[0]
              : undefined
          ) +
          " - " +
          timeFormat(
            this.ruleForm.closeTimeRange
              ? this.ruleForm.closeTimeRange[1]
              : undefined
          ),
      },
      {
        type: "string",
        key: "assignTimeRange",
        value:
          timeFormat(
            this.ruleForm.assignTimeRange
              ? this.ruleForm.assignTimeRange[0]
              : undefined
          ) +
          " - " +
          timeFormat(
            this.ruleForm.assignTimeRange
              ? this.ruleForm.assignTimeRange[1]
              : undefined
          ),
      },
      {
        type: "number",
        key: "isReloan",
        value: this.ruleForm.isReloan,
      },
      {
        type: "number",
        key: "UrgeResult",
        value: this.ruleForm.UrgeResult,
      },
      {
        type: "number",
        key: "outsource",
        value: this.ruleForm.outsource,
      },
      {
        type: "number",
        key: "belongCompany",
        value: Number(this.ruleForm.belongCompany),
      },
      {
        type: "number",
        key: "isRoll",
        value: Number(this.ruleForm.isRoll),
      },
      {
        type: "number",
        key: "isStage",
        value: Number(this.ruleForm.isStage),
      },
      // 逾期原因
      {
        type: "string",
        key: "overdueReason",
        value: this.ruleForm.overdueReason,
      },
      {
        type: "array",
        key: "roleList",
        value: this.ruleForm.roleList,
      },
    ];
    arg = setValue(arg, params);
    return arg;
  }
  //  手动升级工单的功能
  // message ManualUpgradeTicketReq{
  //   CommonIn CommonIn = 1;
  //   int64 OverdueDay = 2;
  // }
  private async getTicketListExcel() {
    if (
      this.ruleForm.ticketId ||
      this.ruleForm.orderId ||
      this.ruleForm.caseId ||
      this.ruleForm.itemId ||
      this.ruleForm.assignName ||
      this.ruleForm.assignUId ||
      this.ruleForm.callRecordId ||
      this.ruleForm.createTimeRange ||
      this.ruleForm.completeTimeRange ||
      this.ruleForm.closeTimeRange ||
      this.ruleForm.assignTimeRange
    ) {
      let request: any = new GetVoipQITicketListReq();
      request.setCommonin(setCommon());
      request.setPagein(
        setPage(
          this.pageIndex,
          this.pageSize,
          this.sortCondition.prop,
          this.sortCondition.order
        )
      );
      request.setItemid(Number(this.ruleForm.itemId)); //this.ruleForm.itemId
      request.setTicketid(this.ruleForm.ticketId);
      request.setOrderid(this.ruleForm.orderId);
      if (this.ruleForm.Aitimerange && this.ruleForm.Aitimerange[0]) {
        request.setAitimerange(
          timeFormat(this.ruleForm.Aitimerange[0]) +
            " - " +
            timeFormat(this.ruleForm.Aitimerange[1])
        );
      }

      request.setAiscorerange(
        this.ruleForm.Aiscorerange1 + " - " + this.ruleForm.Aiscorerange2 + ""
      );
      request.setFinalscorerange(
        this.ruleForm.finalscore1 + " - " + this.ruleForm.finalscore2 + ""
      );
      request.setAistatus(this.ruleForm.Aistatus);
      request.setHumanscorerange(
        this.ruleForm.Humanscorerange1 +
          " - " +
          this.ruleForm.Humanscorerange2 +
          ""
      );
      // request.setCustomerid(this.ruleForm.customerId);
      request.setCaseid(this.ruleForm.caseId);
      request.setStatus(
        this.ruleForm.status ? this.ruleForm.status.join() : ""
      );
      request.setAssignname(this.ruleForm.assignName);
      request.setAssignuid(this.ruleForm.assignUId);
      //  request.setRoleIDs(this.ruleForm.isReloan);
      request.setCallrecordid(this.ruleForm.callRecordId); //录音id
      request.setCollectionname(this.ruleForm.collectionName);
      if (this.ruleForm.createTimeRange && this.ruleForm.createTimeRange[0]) {
        request.setCreatetimerange(
          timeFormat(this.ruleForm.createTimeRange[0]) +
            " - " +
            timeFormat(this.ruleForm.createTimeRange[1])
        );
      }
      if (
        this.ruleForm.completeTimeRange &&
        this.ruleForm.completeTimeRange[0]
      ) {
        request.setCompletetimerange(
          timeFormat(this.ruleForm.completeTimeRange[0]) +
            " - " +
            timeFormat(this.ruleForm.completeTimeRange[1])
        );
      }
      if (this.ruleForm.closeTimeRange && this.ruleForm.closeTimeRange[0]) {
        request.setClosetimerange(
          timeFormat(this.ruleForm.closeTimeRange[0]) +
            " - " +
            timeFormat(this.ruleForm.closeTimeRange[1])
        );
      }
      if (this.ruleForm.assignTimeRange && this.ruleForm.assignTimeRange[0]) {
        request.setAssigntimerange(
          timeFormat(this.ruleForm.assignTimeRange[0]) +
            " - " +
            timeFormat(this.ruleForm.assignTimeRange[1])
        );
      }
      ticketClient.getVoipQITicketListExcel(
        request,
        {},
        (err: any, response: any) => {

          if (response) {
            this.isGetTicketListExcelActionDone = false;
            // this.isGetTicketListExcelActionDone = response.loading
            //    ? response.loading
            //    : false;
            if (response.array[3] && response.array[3].length > 0) {
              const blob = new Blob([response.array[3]], {
                type: "application/vnd.ms-excel;charset=utf-8",
              });
              downloadFile(blob, response.array[2]);
            } else {
              this.isGetTicketListExcelActionDone = false;
              this.$message.error(response.array[0][1]);
            }
          }
          if (err) {
            this.isGetTicketListExcelActionDone = false;
            errorMsg(err);
          }
        }
      );
    } else {
      this.isGetTicketListExcelActionDone = false;
      this.$message.error(this.$tc("dashbordDy.queryConditions"));
    }
  }

  // //  导出功能
  // private async getTicketListExcel() {
  //   if (this.limitTimeRange()) {
  //     if (this.dwGetTicketListReqParamsNeed()) {
  //       let _arg = this.dwGetTicketListReqParams();
  //       const { getTicketListExcel }: any = await import(
  //         "@/request/getTicketList"
  //       );
  //       let response = await getTicketListExcel(_arg, this);
  //       if (response) {
  //         this.isGetTicketListExcelActionDone = response.loading
  //           ? response.loading
  //           : false;
  //         if (response.array[3] && response.array[3].length > 0) {
  //           const blob = new Blob([response.array[3]], {
  //             type: "application/vnd.ms-excel;charset=utf-8",
  //           });
  //           downloadFile(blob, response.array[2]);
  //         } else {
  //           this.isGetTicketListExcelActionDone = false;
  //           this.$message.error(response.array[0][1]);
  //         }
  //       } else {
  //         this.isGetTicketListExcelActionDone = false;
  //       }
  //     } else {
  //       this.isGetTicketListExcelActionDone = false;
  //     }
  //   } else {
  //     this.isGetTicketListExcelActionDone = false;
  //   }
  // }
  private getTicketList() {
    if (
      this.ruleForm.ticketId ||
      this.ruleForm.orderId ||
      this.ruleForm.caseId ||
      this.ruleForm.itemId ||
      this.ruleForm.assignName ||
      this.ruleForm.assignUId ||
      this.ruleForm.callRecordId ||
      this.ruleForm.createTimeRange ||
      this.ruleForm.completeTimeRange ||
      this.ruleForm.closeTimeRange ||
      this.ruleForm.assignTimeRange
    ) {
      let request: any = new GetVoipQITicketListReq();
      request.setCommonin(setCommon());
      request.setPagein(
        setPage(
          this.pageIndex,
          this.pageSize,
          this.sortCondition.prop,
          this.sortCondition.order
        )
      );
      request.setItemid(Number(this.ruleForm.itemId)); //this.ruleForm.itemId
      request.setTicketid(this.ruleForm.ticketId);
      request.setOrderid(this.ruleForm.orderId);
      // request.setCustomerid(this.ruleForm.customerId);
      request.setCaseid(this.ruleForm.caseId);
      request.setStatus(
        this.ruleForm.status ? this.ruleForm.status.join() : ""
      );
      request.setAssignname(this.ruleForm.assignName);
      request.setAssignuid(this.ruleForm.assignUId);
      if (this.ruleForm.Aitimerange && this.ruleForm.Aitimerange[0]) {
        request.setAitimerange(
          timeFormat(this.ruleForm.Aitimerange[0]) +
            " - " +
            timeFormat(this.ruleForm.Aitimerange[1])
        );
      }

      request.setAiscorerange(
        this.ruleForm.Aiscorerange1 + " - " + this.ruleForm.Aiscorerange2 + ""
      );
      request.setAistatus(this.ruleForm.Aistatus);
      request.setHumanscorerange(
        this.ruleForm.Humanscorerange1 +
          " - " +
          this.ruleForm.Humanscorerange2 +
          ""
      );
      request.setFinalscorerange(
        this.ruleForm.finalscore1 + " - " + this.ruleForm.finalscore2 + ""
      );
      //  request.setRoleIDs(this.ruleForm.isReloan);
      request.setCallrecordid(this.ruleForm.callRecordId); //录音id
      request.setCollectionname(this.ruleForm.collectionName);
      if (this.ruleForm.createTimeRange && this.ruleForm.createTimeRange[0]) {
        request.setCreatetimerange(
          timeFormat(this.ruleForm.createTimeRange[0]) +
            " - " +
            timeFormat(this.ruleForm.createTimeRange[1])
        );
      }
      if (
        this.ruleForm.completeTimeRange &&
        this.ruleForm.completeTimeRange[0]
      ) {
        request.setCompletetimerange(
          timeFormat(this.ruleForm.completeTimeRange[0]) +
            " - " +
            timeFormat(this.ruleForm.completeTimeRange[1])
        );
      }
      if (this.ruleForm.closeTimeRange && this.ruleForm.closeTimeRange[0]) {
        request.setClosetimerange(
          timeFormat(this.ruleForm.closeTimeRange[0]) +
            " - " +
            timeFormat(this.ruleForm.closeTimeRange[1])
        );
      }
      if (this.ruleForm.assignTimeRange && this.ruleForm.assignTimeRange[0]) {
        request.setAssigntimerange(
          timeFormat(this.ruleForm.assignTimeRange[0]) +
            " - " +
            timeFormat(this.ruleForm.assignTimeRange[1])
        );
      }
      ticketClient.getVoipQITicketList(
        request,
        {},
        (err: any, response: any) => {

          if (response) {
            let data: any = response.toObject();
            this.isGetTicketListActionDone = false;
            let _fuc = this.getTicketListFuc;
            handleResponse(data, _fuc);
            // if (!data.commonout || (data.commonout.code == 0)) {
            //   this.ticketStatusOptions = data.ticketstatusList;
            //   this.ticketTypeOptions = data.ticketitemList;
            //   this.UrgeResultOptions = data.urgeresultmapMap;
            //   this.belongCompanyOptions = data.entrustcompanymapList;
            // } else if (data.code == 100100 || data.code == 100101) {
            //   this.$router.push("./login");
            // } else {
            //   this.$message.error(data.commonout.errmsg || data.message);
            // }
          }
          if (err) {
            errorMsg(err);
          }
        }
      );
    } else {
      this.isGetTicketListActionDone = false;
      this.$message.error(this.$tc("dashbordDy.queryConditions"));
    }
  }
  //  进入页面调取，查询需要的select下拉框
  private getTicketListParamFuc(data: any) {
    // this.ticketStatusOptions = data.ticketstatusList;
    data.ticketstatusList.forEach((item: any, index: number) => {
      if (
        item.value == "0" ||
        item.value == "1" ||
        item.value == "4" ||
        item.value == "6"
      ) {
        this.ticketStatusOptions.push(item);
      }
    });
    this.ticketTypeOptions = data.ticketitemList;
    this.UrgeResultOptions = data.urgeresultmapMap;
    this.overdueReasonOptions = data.notrepayreasonmapMap;
    this.belongCompanyOptions = data.entrustcompanymapList;
    this.TicketTagMapOptions = data.tickettagmapMap;
  }
  private getTicketListParam() {
    let request: any = new GetTicketListParamReq();
    request.setCommonin(setCommon());
    ticketClient.getTicketListParam(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        let _fuc = this.getTicketListParamFuc;
        handleResponse(data, _fuc);
        // if (!data.commonout || (data.commonout.code == 0)) {
        //   this.ticketStatusOptions = data.ticketstatusList;
        //   this.ticketTypeOptions = data.ticketitemList;
        //   this.UrgeResultOptions = data.urgeresultmapMap;
        //   this.belongCompanyOptions = data.entrustcompanymapList;
        // } else if (data.code == 100100 || data.code == 100101) {
        //   this.$router.push("./login");
        // } else {
        //   this.$message.error(data.commonout.errmsg || data.message);
        // }
      }
      if (err) {
        errorMsg(err);
      }
    });
  }
  private searchUserFuc(data: any) {
    if (data.userinfosList) {
      this.userPagerCount = data.pageout.total;
      this.userData = data.userinfosList;
      this.searchUserIds = [];
      this.userData.forEach((item: any) => {
        this.searchUserIds.push(item.id);
      });
      this.batchGetLoginInfo();
    }
  }
  private searchUser() {
    let searchRequest: any = new SearchUserReq();
    searchRequest.setCommonin(setCommon());
    searchRequest.setName(this.userForm.name);
    searchRequest.setEmail(this.userForm.email);
    searchRequest.setUsergroup(this.userForm.role);
    searchRequest.setPagein(setPage(this.userPageIndex, this.pageSize));
    client.searchUser(searchRequest, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        let _fuc = this.searchUserFuc;
        handleResponse(data, _fuc);
        if (data.commonout.code == 102) {
          this.pagerCount = 0;
          this.userData = [];
        }
        // if (!data.commonout || (data.commonout.code == 0)) {
        //   if (data.userinfosList) {
        //     this.userPagerCount = data.pageout.total;
        //     this.userData = data.userinfosList;
        //     this.searchUserIds = [];
        //     this.userData.forEach((item: any) => {
        //         this.searchUserIds.push(item.id);
        //     });
        //     this.batchGetLoginInfo();
        //   }
        // } else if (data.commonout.code == 102) {
        //   this.pagerCount = 0;
        //   this.userData = [];
        // } else {
        //   this.$message.error(data.commonout.errmsg);
        // }
      }
      if (err) {
        errorMsg(err);
      }
      this.isSearchUserActionDone = false;
    });
  }
  private batchAssignTicketFuc(data: any) {
    this.showDialogType = 0;
    this.getTicketList();
    this.$message({
      type: "success",
      message: "submit successfully!",
    });
  }
  private batchAssignTicket() {
    const arr = this.selectedTicketIds.map((item: any) => {
      return "" + item;
    }); // 转换类型为string array
    let request: any = new BatchAssignTicketReq();
    request.setCommonin(setCommon());
    request.setItemid(105);
    request.setAssignuid(this.selectedAssignUser.id);
    request.setTicketidsList(arr);
    ticketClient.batchAssignTicket(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        let _fuc = this.batchAssignTicketFuc;
        handleResponse(data, _fuc);
        // if (!data.commonout || (data.commonout.code == 0)) {
        //   this.showDialogType = 0;
        //   this.getTicketList();
        //   this.$message({
        //     type: "success",
        //     message: "提交成功!"
        //   });
        // } else {
        //   this.$message.error(data.commonout.errmsg);
        // }
      }
      if (err) {
        errorMsg(err);
      }
    });
  }

  private batchRecycleTicketFuc(data: any) {
    this.getTicketList();
    this.$message({
      type: "success",
      message: "submit successfully!",
    });
  }
  private batchRecycleTicket() {
    const arr = this.selectedTicketIds.map((item: any) => {
      return "" + item;
    }); // 转换类型为string array
    let request: any = new BatchRecycleTicketReq();
    request.setCommonin(setCommon());
    request.setItemid(105);
    request.setTicketidsList(arr);
    ticketClient.batchRecycleTicket(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        let _fuc = this.batchRecycleTicketFuc;
        handleResponse(data, _fuc);
        // if (!data.commonout || (data.commonout.code == 0)) {
        //   this.getTicketList();
        //   this.$message({
        //     type: "success",
        //     message: "提交成功!"
        //   });
        // } else {
        //   this.$message.error(data.commonout.errmsg);
        // }
      }
      if (err) {
        errorMsg(err);
      }
    });
  }

  private batchEntrustTicketFuc(data: any) {
    this.getTicketList();
    this.$message({
      type: "success",
      message: "submit successfully!",
    });
    this.closeDialog();
    this.getTicketListAction();
  }
  private batchEntrustTicket() {
    const arr = this.selectedTicketIds.map((item: any) => {
      return "" + item;
    }); // 转换类型为string array
    let request: any = new BatchEntrustTicketReq();
    request.setCommonin(setCommon());
    request.setItemid(this.ruleForm.itemId);
    request.setTicketidsList(arr);
    request.setEntrustcompany(Number(this.companyValue));
    ticketClient.batchEntrustTicket(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        let _fuc = this.batchEntrustTicketFuc;
        handleResponse(data, _fuc);
        // if (!data.commonout || (data.commonout.code == 0)) {
        //   this.getTicketList();
        //   this.$message({
        //     type: "success",
        //     message: "提交成功!"
        //   });
        //   this.closeDialog();
        //   this.getTicketListAction();
        // } else if (data.code == 100100 || data.code == 100101) {
        //   this.$router.push("./login");
        // } else {
        //   this.$message.error(data.commonout.errmsg);
        // }
      }
      if (err) {
        errorMsg(err);
      }
    });
  }

  private rollApplyTicketFuc(data: any) {
    this.getTicketList();
    this.$message({
      type: "success",
      message: "submit successfully!",
    });
  }
  private rollApplyTicket() {
    let request: any = new RollApplyTicketReq();
    request.setCommonin(setCommon());
    request.setItemid(this.ruleForm.itemId);
    request.setTicketidsList(this.selectedTicketIds);
    ticketClient.rollApplyTicket(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        let _fuc = this.rollApplyTicketFuc;
        handleResponse(data, _fuc);
        // if (!data.commonout || (data.commonout.code == 0)) {
        //   this.getTicketList();
        //   this.$message({
        //     type: "success",
        //     message: "提交成功!"
        //   });
        // } else if (data.code == 100100 || data.code == 100101) {
        //   this.$router.push("./login");
        // } else {
        //   this.$message.error(data.commonout.errmsg);;
        // }
      }
      if (err) {
        errorMsg(err);
      }
    });
  }

  private reduceTicketFuc(data: any) {
    this.showTimesTips = {
      showlefttotaltips: data.showlefttotaltips,
      lefttotalgroup: data.lefttotalgroup,
      lefttotalstaff: data.lefttotalstaff,
    };
    if (this.showDialogType === 2) {
      this.leftamount = data.amount - data.amountpayed - data.amountreduced;
      this.principalData = [
        {
          label1: this.$t("ticket.DueDate"),
          value1: timeFormat(data.shouldrepaydate),
          label2: this.$t("ticket.ActualPaymentDate"),
          value2: timeFormat(data.actuallyrepaydate),
          label3: this.$t("ticket.RemissionDay"),
          value3: timeFormat(data.latestreducedate),
        },
        {
          label1: this.$t("ticket.Principal"),
          value1: data.amount,
          label2: this.$t("ticket.ActualRepaymentPrincipal"),
          value2: data.amountpayed,
          label3: this.$t("ticket.ReferralDirector"),
          value3: data.amountreduced,
          label4: this.$t("ticket.TheRemainingPrincipalCanBeReduced"),
          value4: data.amount - data.amountpayed - data.amountreduced,
        },
      ];
      if (data.showleftpercenttips) {
        this.principalData.push({
          label1: this.$t("ticketFhb.IndividualDeductibleAmount"),
          value1: data.leftamounttotalstaff,
          label2: this.$t("ticketFhb.GroupDeductibleAmount"),
          value2: data.leftamounttotalgroup,
        });
      }
    } else if (this.showDialogType === 3) {
      this.penaltyData = [
        {
          label1: this.$t("ticket.GracePeriodInterest"),
          value1: data.graceperiodinterest,
          label2: this.$t("ticket.ActualInterestPaidDuringGracePeriod"),
          value2: data.graceperiodinterestpayed,
          label3: this.$t("ticket.GracePeriodInterestRemissiond"),
          value3: data.graceperiodinterestreduced,
          label4: this.$t(
            "ticket.RemainingDeductibleInterestFromTheGracePeriod"
          ),
          value4: data.graceperiodinterest - data.graceperiodinterestpayed,
        },
        {
          label1: this.$t("ticket.PenaltyAndExtraFeesThatShouldBePaid"),
          value1: data.penalty,
          label2: this.$t("ticket.PenaltyInterestActuallyPaid"),
          value2: data.penaltypayed,
          label3: this.$t("ticket.RemissiondPenaltyInterest"),
          value3: data.penaltyreduced,
          label4: this.$t("ticket.TheRemainingPenaltyInterestCanBeRemission"),
          value4: data.penalty - data.penaltypayed - data.penaltyreduced,
        },
      ];
    }
  }
  private reduceTicket(row: any) {
    let request: any = new ReduceTicketReq();
    request.setCommonin(setCommon());
    request.setItemid(Number(row.itemid));
    request.setTicketid(Number(row.id));
    ticketClient.reduceTicket(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();

        let _fuc = this.reduceTicketFuc;
        handleResponse(data, _fuc);
        // if (!data.commonout || (data.commonout.code == 0)) {
        //   if (this.showDialogType === 2) {
        //     this.principalData = [
        //       {
        //         label1: this.$t('ticket.DueDate'),
        //         value1: timeFormat(data.shouldrepaydate),
        //         label2: this.$t('ticket.ActualPaymentDate'),
        //         value2: timeFormat(data.actuallyrepaydate),
        //         label3: this.$t('ticket.RemissionDay'),
        //         value3: timeFormat(data.latestreducedate)
        //       },
        //       {
        //         label1: this.$t('ticket.Principal'),
        //         value1: data.amount,
        //         label2: this.$t('ticket.ActualRepaymentPrincipal'),
        //         value2: data.amountpayed,
        //         label3: this.$t('ticket.ReferralDirector'),
        //         value3: data.amountreduced,
        //         label4: this.$t('ticket.TheRemainingPrincipalCanBeReduced'),
        //         value4: data.amount - data.amountpayed - data.amountreduced
        //       }
        //     ];
        //   } else if (this.showDialogType === 3) {
        //     this.penaltyData = [
        //       {
        //         label1: this.$t('ticket.GracePeriodInterest'),
        //         value1: data.graceperiodinterest,
        //         label2: this.$t('ticket.ActualInterestPaidDuringGracePeriod'),
        //         value2: data.graceperiodinterestpayed,
        //         label3: this.$t('ticket.GracePeriodInterestRemissiond'),
        //         value3: data.graceperiodinterestreduced,
        //         label4: this.$t('ticket.RemainingDeductibleInterestFromTheGracePeriod'),
        //         value4: data.graceperiodinterest - data.graceperiodinterestpayed
        //       },
        //       {
        //         label1: this.$t('ticket.PenaltyAndExtraFeesThatShouldBePaid'),
        //         value1: data.penalty,
        //         label2: this.$t('ticket.PenaltyInterestActuallyPaid'),
        //         value2: data.penaltypayed,
        //         label3: this.$t('ticket.RemissiondPenaltyInterest'),
        //         value3: data.penaltyreduced,
        //         label4: this.$t('ticket.TheRemainingPenaltyInterestCanBeRemission'),
        //         value4: data.penalty - data.penaltypayed - data.penaltyreduced
        //       }
        //     ];
        //   }
        // } else if (data.code == 100100 || data.code == 100101) {
        //   this.$router.push("./login");
        // } else {
        //   this.$message.error(data.commonout.errmsg);;
        // }
      }
      if (err) {
        errorMsg(err);
      }
    });
  }
  private doReduceTicketFuc() {
    if (this.showDialogType === 2) {
      this.resetForm("principalForm");
    } else if (this.showDialogType === 3) {
      this.resetForm("penaltyForm");
    }
    this.showDialogType = 0;
    this.getTicketList();
    this.$message({
      type: "success",
      message: "submit successfully!",
    });
  }

  // 减免本金  拆分后接口
  private async doReducePrincipal() {
    if (this.leftamount >= this.principalForm.principal) {
      this.principalDone = true;
      let _arg: any = {
        TicketId: Number(this.isEditTicketId),
        ItemId: Number(this.isEditRow.itemid),
        ReductionAmount: Number(this.principalForm.principal),
        Reason: this.principalForm.reason,
      };
      const {
        getReducePrincipalReq,
        getReducePrincipalRequest,
      }: any = await import("@/request/reducePrincipalAndOther");
      let res = await getReducePrincipalRequest.handleHttp(
        getReducePrincipalReq(_arg),
        this
      );
      if (res && res.right) {
        this.principalDone = false;
        this.doReduceTicketFuc();
      } else {
        this.principalDone = false;
      }
    } else {
      let _text = this.$tc("OrderStatus.beyondCompareSubmitFailed");
      this.$message({
        type: "error",
        message: _text,
      });
    }
  }
}
